import { render, staticRenderFns } from "./comparyAlarmList.vue?vue&type=template&id=c123c2fc&scoped=true"
import script from "./comparyAlarmList.vue?vue&type=script&lang=js"
export * from "./comparyAlarmList.vue?vue&type=script&lang=js"
import style0 from "./comparyAlarmList.vue?vue&type=style&index=0&id=c123c2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c123c2fc",
  null
  
)

export default component.exports